// extracted by mini-css-extract-plugin
module.exports = {"toggler":"DashboardActionsDesktop_toggler__9rz1_","navList":"DashboardActionsDesktop_navList__kThhM"};